import React, { useState } from "react";
import EntryColor from "../container/EntryColor";
import ModalOpenBetsChart from "../modals/ModalOpenBetsChart";
import SwitchActiveBetsColum from "../utilities/SwitchActiveBetsColum";
import ButtonOpenBetsBetType from "../utilities/ButtonOpenBetsBetType";

const Superfecta = ({
  charts,
  getOpenBetsChartModal,
  openBetsChartInfo,
  setOpenBetsChartInfo,
  userInfo,
  idSuperfecta,
  raceID,
  voidTickets,
  callTicketVoidListFrom,
  selectedTicketsVoidScore,
  setSelectedTicketsVoidScore,
  selectAllTickets,
  setSelectAllTickets,
  scoreTickets,
  setCallTicketVoidListFrom,
  setSelectionsSelected,
  getCharts,
}) => {
  const [showBetsColumnSuperfecta, setShowBetsColumnSuperfecta] =
    useState(false);

  var tableContent = [],
    headers;

  if (charts) {
    tableContent = charts.map((chart, i) => {
      let selections = chart.Selections.split(",");
      return (
        <tr key={i}>
          <td>
            <EntryColor
              entryNum={parseInt(selections[0])}
              saddleNum={selections[0]}
            />
          </td>
          <td>
            <EntryColor
              entryNum={parseInt(selections[1])}
              saddleNum={selections[1]}
            />
          </td>
          <td>
            <EntryColor
              entryNum={parseInt(selections[2])}
              saddleNum={selections[2]}
            />
          </td>
          <td>
            <EntryColor
              entryNum={parseInt(selections[3])}
              saddleNum={selections[3]}
            />
          </td>
          <td style={{ fontWeight: "bold", verticalAlign: "middle" }}>
            ${chart.Amount.toFixed(2)}
          </td>
          {showBetsColumnSuperfecta && (
            <td
              style={{ verticalAlign: "middle" }}
              className="cantBets"
              data-toggle="modal"
              data-target="#openBetsChartModal"
              onClick={() => {
                getOpenBetsChartModal(idSuperfecta, chart.Selections);
                setSelectionsSelected(chart.Selections);
              }}
            >
              {chart.BetCount}
            </td>
          )}
        </tr>
      );
    });
  }

  headers = (
    <tr className="text-center">
      <th>1ST LEG</th>
      <th>2ND LEG</th>
      <th>3RD LEG</th>
      <th>4TH LEG</th>
      <th>Money</th>
      {showBetsColumnSuperfecta && <th># Bets</th>}
    </tr>
  );

  return (
    <>
      <ModalOpenBetsChart
        openBetsChartInfo={openBetsChartInfo}
        setOpenBetsChartInfo={setOpenBetsChartInfo}
        userInfo={userInfo}
        wagerTypeId={idSuperfecta}
        voidTickets={voidTickets}
        callTicketVoidListFrom={callTicketVoidListFrom}
        selectedTicketsVoidScore={selectedTicketsVoidScore}
        setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
        selectAllTickets={selectAllTickets}
        setSelectAllTickets={setSelectAllTickets}
        scoreTickets={scoreTickets}
        setCallTicketVoidListFrom={setCallTicketVoidListFrom}
        getCharts={getCharts}
      />
      <div className="row">
        <div className="col-sm-6">
          <SwitchActiveBetsColum
            showBetsColumn={showBetsColumnSuperfecta}
            setShowBetsColumn={setShowBetsColumnSuperfecta}
          />
        </div>
        <div className="col-sm-6" style={{ textAlign: "right" }}>
          <ButtonOpenBetsBetType
            ticketType={idSuperfecta}
            raceID={raceID}
            userInfo={userInfo}
            openBetsChartInfo={openBetsChartInfo}
            setOpenBetsChartInfo={setOpenBetsChartInfo}
          />
        </div>
      </div>

      <table className="table table-striped table-sm mt-2">
        <thead>{headers}</thead>
        <tbody className="table-sm text-center table-bordered">
          {tableContent}
        </tbody>
      </table>
    </>
  );
};

export default Superfecta;
